import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';

/**
 * HttpClient for public storage (S3) requests.
 * Built on HttpBackend so no interceptor runs: S3 rejects the Authorization
 * header that the app interceptor adds when there is a session.
 */
@Injectable({
  providedIn: 'root'
})
export class StorageHttpClient extends HttpClient {

  constructor(handler: HttpBackend) {
    super(handler);
  }

}
